import React from 'react';
import './LatestProjects.css';

// 🔗 PLACEHOLDER: Replace image imports with your actual project screenshots
// import project1 from '../assets/project1.jpg';
// Then use: image: project1

// ✏️ PLACEHOLDER: Update project titles, categories and image paths
const PROJECTS = [
  {
    id: 1,
    category: 'WEBSITE DESIGN',
    title: 'Atadak Store Design',
    image: '/images/project1.jpeg',       // 🔗 Replace null with your image path e.g. project1
    href: 'https://www.figma.com/proto/XiEnR1ot4Q7v2zILg0AxWI/atadk-Dark-mode?node-id=1035-2415&t=zbwFZriw7rOebu4o-1&scaling=min-zoom&content-scaling=fixed&page-id=0%3A1&starting-point-node-id=790%3A3503',         // 🔗 Replace with your live project link
  },
  {
    id: 2,
    category: 'WEBSITE DESIGN',
    title: 'AI Marketing Labz Web Design',
    image: '/images/project2.jpeg',
    href: 'https://www.figma.com/proto/1MKh3CikjvKdDV8D4C7EYh/Ai-Marketing-labz?node-id=1-2&t=YH15kS57hVEWHU5U-1',
  },
  {
    id: 3,
    category: 'APPLICATION DESIGN',
    title: 'CheckMyStaff Mobile App Design',
    image: '/images/project3.jpeg',
    href: 'https://www.figma.com/proto/DciBReVGHMumgdf54XQGHr/CheckMyStaff-Mobile-App?node-id=331-5378&t=0GH7iNuPE4YQQhkV-1&scaling=scale-down&content-scaling=fixed&page-id=1%3A5&starting-point-node-id=216%3A4353',
  },
];

export default function LatestProjects() {
  return (
    <section className="latest-projects section" id="projects">
      <div className="container">
        <div className="text-center">
          {/* 🔗 PLACEHOLDER: Update label text if needed */}
          <span className="section-label">Recent Work</span>
          <h2 className="section-title">Latest Project</h2>
          <div className="divider" />
        </div>

        <div className="projects-grid">
          {PROJECTS.map((project) => (
            <a
              href={project.href}
              className="project-card"
              key={project.id}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="project-thumb">
                {project.image ? (
                  <img src={project.image} alt={project.title} />
                ) : (
                  <div className="project-thumb-placeholder">
                    <span>🖼️</span>
                    {/* 🔗 PLACEHOLDER: Add project screenshot above */}
                    <p>Add project image</p>
                  </div>
                )}
                <div className="project-overlay">
                  <span className="project-view">View →</span>
                </div>
              </div>
              <div className="project-info">
                <span className="project-category">{project.category}</span>
                <h3 className="project-title">{project.title}</h3>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center" style={{ marginTop: '40px' }}>
          {/* 🔗 PLACEHOLDER: Update href to your portfolio page or Behance/Dribbble */}
          <a href="https://www.behance.net/faheem_graphics" target='_blank' className="btn btn-primary">View All Work</a>
        </div>
      </div>
    </section>
  );
}
